import throttle from "./throttle"

export default function registerDirectives(app: any) {
 throttle(app);
}